/**
 * Enum of role values returned by the backend for account-level users.
 * Backend contract: `role` field on the user object is one of these
 * lowercase strings. UI surfaces the role in role-picker dropdowns
 * (CreateUserDialog, RoleField) and falls back to ASSISTANT on user
 * creation when nothing else is specified.
 */
export const USER_ROLES = {
  PROVIDER: 'provider',
  ASSISTANT: 'assistant',
};
